// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"9e0e67d7","293":"7221852a","670":"8e03015f","718":"b0081301"}[chunkId] + ".chunk.js";
};